export default class TestimonialsComponent {
	constructor() {

		const testimonials_page = document.querySelectorAll('.testimonials-page');

		if (!testimonials_page) return;

		testimonials_page.forEach((testimonial) => {
			const slider_button_next = testimonial.querySelector('.slider-button-next');
			const slider_button_prev = testimonial.querySelector('.slider-button-prev');
			const slider_pagination = testimonial.querySelector('.slider-pagination');

			const swiper = new Swiper(testimonial, {
				loop: true,
				speed: 500,
				grabCursor: true,
				centeredSlides: true,
				effect: "coverflow",

				coverflowEffect: {
					scale: 0.6,
					rotate: 1,
					stretch: 145,
					depth: 100,
					initialSlide: 1,
					modifier: 1,
					slideShadows: false
				},

				navigation: {
					nextEl: slider_button_next ?? '.slider-button-next',
					prevEl: slider_button_prev ?? '.slider-button-prev',
				},

				pagination: {
					el: slider_pagination ?? '.slider-pagination',
					clickable: true,
				},

				breakpoints: {
					0: {
						slidesPerView: "1",
					},
					768: {
						slidesPerView: "2",
					},
					1200: {
						slidesPerView: "2",
					}
				}
			});
		});
	}
}
new TestimonialsComponent();